import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles branding
 */
export class BrandingService extends BaseService {
	
	static get properties() {		
		return {		
		};
	}
	
	constructor() {	
		super();
	}
	
	async getCurrentBranding() {
		//var brandingService = this;
				
		var branding = await this.makeGETRequest('/api/resource/branding/current', null, {
			headers: {
				'Authorization': ''
			}
		});
//		var promise = new Promise(function(resolve, reject){
//			if (brandingService.branding){
//				resolve(brandingService.branding);
//			} else {
//				
//				//mock for now
//				brandingService.branding = {
//					logoURL: './image/logo-wex.png',
//					backgroundURL: './image/prism.png',
//					loginTitle: 'WEX - Driveline',
//					loginDescripton: 'Fuel Tax',
//					footerCompany: 'WEX',
//					headerBackgroundColor: '#383636',
//					headerTextColor: 'white',		
//					companyTextColor: 'gold',
//					primaryBackgroundColor: '#e41736',
//					primaryTextColor: 'white',		
//					navBackgroundColor: '#e41736',
//					navOffBackgroundColor: '#192434',
//					navTextColor: 'white',
//					menuColor: '#e41736'
//				};
//				
//				resolve(brandingService.branding);
//			}
//		});
		return branding;
	}
	
	async getAllBranding() {
		var data = await this.makeGETRequest('/api/resource/branding');
		return data;
	}
	
	async deleteBranding(brandingId) {
		var results = await this.makeDELETERequest('/api/resource/branding/' + brandingId);
		return results;
	}
	
	async activateBranding(brandingId) {	
		var result = await this.makePUTRequest('/api/resource/branding/' + brandingId + '/activate');
		return result;
	}	

	async inactivateBranding(brandingId) {	
		var result = await this.makePUTRequest('/api/resource/branding/' + brandingId + '/inactivate');
		return result;
	}

	async resetBranding() {	
		var result = await this.makePUTRequest('/api/resource/branding/reset');
		return result;
	}
	
	async saveBranding(branding, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/branding/' + branding.brandingId, branding);
		} else {
			saved = await this.makePOSTRequest('/api/resource/branding', branding);
		}
		return saved;
	}
	
	async copyBranding(branding) {
		var copy = Object.assign({}, branding);
		copy.brandingId = null;
		copy.id = null;
		
		//adjust for max
		if (copy.brandingName.length > 120) {
			copy.brandingName = copy.brandingName.subString(0, 115);
		}		
		copy.brandingName = copy.brandingName + "-copy";
			
		return this.saveBranding(copy, false);
	}
	
};
